import $ from 'jquery';
import initChoiceDropdown from './helpers';
import {choicesInstances} from './select';
import {createCartController} from './cart/controller';
import {createCartStatus} from './cart/status';

export default function cartInteractivity() {
    if (document.querySelector('[data-novastars-checkout]')) return;

    // These controls are also used by the order form and product pages.
    $(document).on('click', '.quantity-btn-increase, .quantity-btn-decrease', function (event) {
        event.preventDefault();
        if (this.disabled || this.closest('.is-cart-busy')) return;
        const input = $(this).closest('.quantity-selector-input').find('.quantity-input');
        const current = Number(input.val()) || 0;
        const min = Number(input.attr('min')) || 0;
        const next = $(this).data('action') === 'decrease' ? Math.max(min, current - 1) : current + 1;
        if (next !== current) input.val(next).trigger('change');
    });

    const root = document.querySelector('.cart');
    const content = root?.querySelector('[data-cart-content]');
    if (!content) return;
    const status = createCartStatus(content.parentElement);
    const money = cents => new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(cents / 100);
    const controller = createCartController({
        ...status,
        render(result) {
            closeEditor();
            destroySelects(content);
            content.innerHTML = result.html;
            content.querySelectorAll('select.js-select').forEach(select => choicesInstances.set(select, initChoiceDropdown(select)));
        }
    });
    status.retry(() => controller.load());

    function destroySelects(scope) {
        scope.querySelectorAll('select.js-select').forEach(select => {
            choicesInstances.get(select)?.destroy();
            choicesInstances.delete(select);
        });
    }
    function closeEditor() {
        $(root).find('.mobile-variant-edit-screen, .mobile-edit-overlay').removeClass('is-open');
        document.body.classList.remove('modal-open');
    }
    function selectedProduct(scope) {
        const row = $(scope).find('select[name="new_row"]').val();
        const column = $(scope).find('select[name="new_column"]').val();
        const match = [...scope.querySelectorAll('.matrix-option')].find(option => (!row || option.dataset.row === row) && (!column || option.dataset.column === column));
        if (!match) throw new Error('This variant combination is unavailable. Please choose another variant.');
        return match;
    }
    function variant(scope, item, quantity) {
        try {
            const option = selectedProduct(scope);
            return controller.mutate('variant', {item: Number(item), product: Number(option.dataset.productId), quantity});
        } catch (error) {
            return controller.load().then(() => { status.message(error.message); return false; });
        }
    }
    $(root).on('submit', '.cart-items-form', event => event.preventDefault());
    $(root).on('change', '.cart-item .variant-select', function () {
        if (this.closest('.is-cart-busy')) return;
        const item = this.closest('.cart-item');
        variant(item, item.dataset.itemId, Number($(item).find('.quantity-input-desktop').val()));
    });
    $(root).on('change', '.cart-item-edit .quantity-input', function () {
        if (this.closest('.is-cart-busy')) return;
        controller.mutate('quantity', {item: Number(this.closest('.cart-item').dataset.itemId), quantity: Number(this.value)});
    });
    $(root).on('click', '.remove-cart-item', function (event) {
        event.preventDefault();
        if (this.closest('.is-cart-busy')) return;
        controller.mutate('remove', {item: Number(this.closest('.cart-item').dataset.itemId)});
    });
    $(root).on('click', '.edit-cart-item', function (event) {
        event.preventDefault();
        if (this.closest('.is-cart-busy')) return;
        if (Foundation.MediaQuery.atLeast('xlarge')) return;
        const item = this.closest('.cart-item');
        const modal = root.querySelector('.mobile-variant-edit-screen');
        modal.dataset.currentEditId = item.dataset.itemId;
        modal.dataset.singlePrice = item.querySelector('.cart-item-price').dataset.price;
        $(modal).find('.product-info img').attr('src', $(item).find('figure img').attr('src'));
        $(modal).find('.product-info .name').text($(item).find('.item-title').text());
        $(modal).find('.product-info .variant').text($(item).find('.options-mobile').text());
        $(modal).find('.product-info .price').text($(item).find('.cart-item-price').text());
        destroySelects(modal);
        for (const [dimension, target] of [['column', '.column-variant'], ['row', '.row-variant']]) {
            const holder = modal.querySelector(target);
            holder.replaceChildren();
            const original = item.querySelector(`select[name="new_${dimension}"]`);
            holder.hidden = !original;
            if (!original) continue;
            // Copy only the options, not Choices' hidden/accessibility state.
            const select = document.createElement('select');
            select.name = original.name;
            select.className = 'variant-select-mobile js-select';
            select.innerHTML = original.innerHTML;
            select.value = original.value;
            holder.append(select);
            choicesInstances.set(select, initChoiceDropdown(select));
        }
        modal.querySelector('.matrix-options-container').innerHTML = item.querySelector('.matrix-options')?.outerHTML || '';
        $(modal).find('.quantity-input').val($(item).find('.quantity-input-desktop').val());
        $(modal).addClass('is-open');
        $(root).find('.mobile-edit-overlay').addClass('is-open');
        document.body.classList.add('modal-open');
        preview();
    });
    $(root).on('click', '.mobile-edit-overlay', closeEditor);
    $(root).on('change', '.mobile-variant-edit-screen select, .mobile-variant-edit-screen .quantity-input', preview);
    function preview() {
        const modal = root.querySelector('.mobile-variant-edit-screen');
        const quantity = Number($(modal).find('.quantity-input').val());
        let price = Number(modal.dataset.singlePrice);
        if (modal.querySelector('select')) {
            try {
                const option = selectedProduct(modal);
                price = Number(option.dataset.price);
                $(modal).find('.product-info img').attr('src', option.dataset.image);
                const labels = [...modal.querySelectorAll('select')].map(select => select.selectedOptions[0]?.textContent).filter(Boolean);
                $(modal).find('.product-info .variant').text(labels.join(' | '));
            } catch (_) { return; }
        }
        $(modal).find('.product-info .price').text(money(price * quantity));
        $(modal).find('.discount-badge').prop('hidden', true);
    }
    $(root).on('click', '.save-product-variant-mobile', async function (event) {
        event.preventDefault();
        if (root.querySelector('.is-cart-busy')) return;
        const modal = this.closest('.mobile-variant-edit-screen');
        const item = Number(modal.dataset.currentEditId);
        const quantity = Number($(modal).find('.quantity-input').val());
        // Send the intended action directly; never trigger another input's change event.
        if (quantity === 0) await controller.mutate('remove', {item});
        else if (modal.querySelector('select')) await variant(modal, item, quantity);
        else await controller.mutate('quantity', {item, quantity});
    });
    controller.load();
}
